export const COVERAGE_LIST = "COVERAGE_LIST";
export const CLEAR = "CLEAR";
export const COVERAGE_WORK_TYPES = "COVERAGE_WORK_TYPES";
export const WORK_TYPES = "WORK_TYPES";
export const COVERAGE_POST_CODES = "COVERAGE_POST_CODES";
export const FOUND_LOCATIONS = "FOUND_LOCATIONS";
export const FOUND_COVERAGE_REGIONS = "FOUND_COVERAGE_REGIONS";
export const SELECTED_COVERAGE_AREAS = "SELECTED_COVERAGE_AREAS";
export const SELECTED_COVERAGE = "SELECTED_COVERAGE";
